import React from 'react';
import { IRoute } from './interfaces/Routing.types';

export const RoutesContext = React.createContext<IRoute[] | null>(null);
